<template>
  <div class="score-input-wrap">
    <input v-if="![30, 45, 46, 54,200,67,68,69,73,78].includes(subject_id)" v-model.trim.number.lazy="result"
           type="text"
           :class="{'score-input': true, 'err-border': errFlag,'exam': type!=='common' && type!=='physical_train' && type!=='goalkeeper_train' && type}"
           :placeholder="holderTips"
           :disabled="disabled_status">
    <p  v-if="![30, 45, 46, 54,200,67,68,69,73,78].includes(subject_id)" v-show="errFlag"
        class="err-tips">{{errTips}}</p>
    <select v-if="[30, 45, 46, 54,200,67,68,69,73,78].includes(subject_id)" id="football_ability" v-model.trim.select.lazy="football_ability"
            :class="{'football_ability': true, 'err-border': errSelectFlag}"
            :disabled="disabled_status">
      <option value="">请选择</option>
      <option v-for="(ability, index) in football_ability_list" :key="index" :value="ability.label">{{ability.value}}</option>
    </select>
    <p v-if="[30, 45, 46, 54,200,67,68,69,73,78].includes(subject_id)" v-show="errSelectFlag"
       class="err-tips">{{errSelectTips}}</p>
  </div>
</template>

<script>
  export default {
    name: "score-input",
    props: {
      val: {
        type: [String, Number],
        required: true
      },
      subject_id: {
        type:  Number,
        required: true
      },
      title: {
        type: String,
        required: false,
      },
      err: {
        type: Boolean,
        required: true
      },
      disabled_status: {
        type: Boolean,
        required: false,
        default:false
      },
      holderTips: {
        type: String,
        required: false,
        default: "请输入成绩"
      },
      errTips: {
        type: String,
        required: false,
        default: "请输入成绩"
      },
      type:{
        type: String,
        required: false,
        default: ""
      },
      errSelectTips: {
        type: String,
        required: false,
        default: "此项为必选项"
      },
    },
    data() {
      return {
        football_ability_list: [{
          value: '卓越',
          label: '卓越'
        },{
          value: '优秀',
          label: '优秀'
        },{
          value: '良好',
          label: '良好'
        },{
          value: '一般',
          label: '一般'
        },{
          value: '较差',
          label: '较差'
        }]
      };
    },
    computed: {
      result: {
        get() {
          return this.val;
        },
        set(val) {
          // console.log(val);
          const num = Number(val);
          let condiation
          if (this.type==='make_up_exam' || this.type==='physical_make_up_exam'){
             condiation= val === "" || num < 0 || num > 70 || isNaN(num)
          }else{
            condiation= val === "" || num < 0 || num > 100 || isNaN(num)
          }
          if(condiation) {
            this.errFlag = true;
            this.$emit("update:val", "");
            this.$emit("change");
            return false;
          }
          this.errFlag = false;
          this.$emit("update:val", val);
          this.$emit("change");
        },
      },
      football_ability: {
        get() {
          return this.val;
        },
        set(val) {
           if (val==="") {
             this.errSelectFlag = true;
             this.$emit("update:val", "");
             this.$emit("change");
             return false;
           }
          this.errSelectFlag = false;
          this.$emit("update:val", val);
          this.$emit("change");
        },
      },
      errFlag: {
        get() {
          return this.err;
        },
        set(bool) {
          this.$emit("update:err", bool);
        },
      },
      errSelectFlag: {
        get() {
          return this.err;
        },
        set(bool) {
          this.$emit("update:err", bool);
        },
      },
    },
  }
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable';
  .score-input-wrap {
    height: 60px;
    .score-input {
      width: 115px;
      height: 28px;
      margin: 10px 0 0;
      color: $color_black;
      text-align: center;
      border-radius: 5px;
      outline: none;
      &.err-border {
        border: 1px solid $color_err;
      }
    }
    .exam{
      width: 260px;
    }
    .football_ability{
      // padding 0 22%
      width: 115px;
      height: 28px;
      color: #000;
      margin: 10px 0 0;
      text-align: center;
      border-radius: 5px;
      outline: none;
      &.err-border {
        border: 1px solid $color_err;
      }
    }
    .err-tips {
      color: $color_err;
      font-size: $font_size_base;
    }
  }
</style>
